import PropTypes from 'prop-types';
import React from 'react';
import Card from 'components/Card';
import CardText from 'components/Card/Text';
import CardHeader from 'components/Card/Header';
import { Dialog } from '@mui/material';
import { Close } from '@mui/icons-material';
import Button from '@mui/material/Button';
import makeStyles from '@mui/styles/makeStyles';
import useIsMobile from 'lib/useIsMobile';
import paidMed from '../../../assets/paidmedia.png';
import paidMedMob from '../../../assets/paidmediamob.png';

const styles = {
    dlg: {
        maxWidth: '960px !important',
    },
    dlgMob: {
        maxWidth: '350px !important',
    },
    card: {
        backgroundImage: `url(${paidMed})`,
        overflow: 'scroll',
        height: '620px',
        width: '960px',
        paddingLeft: '2%',
      },
    cardMob: {
        backgroundImage: `url(${paidMedMob})`,
        overflow: 'scroll',
        height: '630px',
        width: '384px',
        backgroundColor: 'white',
    },
    cardTitle: {
        fontWeight: '700 !important',
        fontSize: '42px !important',
        color: '#0076BB !important',
        fontFamily: 'NewOrderBold !important',
    },
    cardTitleMob: {
        fontWeight: '700 !important',
        fontSize: '22px !important',
        color: '#0076BB !important',
        fontFamily: 'NewOrderBold !important',
        maxWidth: '150px',
    },
    cardText: {
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: '22px',
        marginBottom: 10,
        textAlign: 'justify',
        lineHeight: '20px',
        width: '480px',
    },
    cardTextMob: {
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: '16px',
        marginBottom: 5,
        textAlign: 'justify',
        lineHeight: '20px',
        maxWidth: '190px',
    },
    cardDetail: {
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: '22px',
        marginBottom: 10,
        textAlign: 'justify',
        lineHeight: '20px',
        width: '480px',
        marginTop: 30,
    },
    cardDetailMob: {
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: '16px',
        marginBottom: 5,
        textAlign: 'justify',
        lineHeight: '20px',
        width: '280px',
        marginTop: 10,
    },
    list: {
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: '22px',
        marginBottom: 10,
        textAlign: 'justify',
        lineHeight: '20px',
        width: '480px',
        marginTop: 30,
        fontFamily: 'jost',
    },
    listMob: {
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: '16px',
        marginBottom: 5,
        textAlign: 'justify',
        lineHeight: '20px',
        width: '280px',
        marginTop: 10,
        fontFamily: 'jost',
    },
    endTxt: {
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: '22px',
        marginBottom: 10,
        textAlign: 'justify',
        lineHeight: '20px',
        width: '480px',
        marginTop: 30,
    },
    endTxtMob: {
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: '16px',
        marginBottom: 10,
        textAlign: 'justify',
        lineHeight: '20px',
        width: '280px',
        marginTop: 5,
    },
      bulbIconStyle: {
        height: '25px',
        width: '25px',
        display: 'inline-block',
        marginRight: '2%',
      },
      link: {
        color: '#0076BB',
      },
      scoreIcon: {
        width: '12px',
        height: '12px',
        verticalAlign: 'baseline',
        position: 'relative',
        top: '3px',
      },
      scoreIconSM: {
        width: '9px',
        height: '9px',
        verticalAlign: 'baseline',
      },
      alignFlex: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        // marginTop: 20,
      },
};

const PaidMediaDialog = ({ onCancel, open }) => {
  const btnStyle = makeStyles();
  const mobile = useIsMobile();
  return (
    <Dialog modal maxWidth={false} onRequestClose={onCancel} open={open}>
      <Card style={mobile ? styles.cardMob : styles.card}>
        <Close
          style={{
            color: '#000',
            marginLeft: 20,
            marginTop: 12,
            cursor: 'pointer',
          }}
          onClick={onCancel}
        />
        <CardHeader
          titleStyle={mobile ? styles.cardTitleMob : styles.cardTitle}
          title={(
            <span style={{ textAlign: 'left' }}>
              Welcome to Ripple Street!
            </span>
          )}
        />
        <CardText
          noTopPadding
          style={{
            color: '#000000',
            fontFamily: 'jost',
          }}
        >
          <div
            style={mobile ? styles.cardTextMob : styles.cardText}
          >
            Want to join our community and try amazing new products—for free?
            Here’s what you need to know.
          </div>

          <div
            style={mobile ? styles.cardDetailMob : styles.cardDetail}
          >
            <ol style={mobile ? styles.listMob : styles.list}>
              <li style={{ marginBottom: '4%' }}>To gain full access, you&apos;ll need to create a free account, just
                click &quot;Sign In&quot; to get started.
              </li>
              <li style={{ marginBottom: '4%' }}>Browse open events and hit &quot;Apply Now&quot; if you see an event you
                want in on.
              </li>
              <li style={{ marginBottom: '4%' }}>Increase your chances of getting selected by completing the
                activities you see on the event page.
              </li>
              <li style={{ marginBottom: '4%' }}>If you&apos;re selected, we&apos;ll send you a pack of goodies! Then you&apos;ll
                complete a few more activities (writing a review, sharing a photo,
                etc.) to share your experience.
              </li>
            </ol>
            {/* 1. To gain full access, you&apos;ll need to create a free account, just
            click &quot;Sign In&quot; to get started. <br />
            <br />
            2. Browse open events and hit &quot;Apply Now&quot; if you see an event you
            want in on.
            <br />
            <br />
            3. Increase your chances of getting selected by completing the
            activities you see on the event page.
            <br />
            <br />
            4. If you&apos;re selected, we&apos;ll send you a pack of goodies! Then you&apos;ll
            complete a few more activities (writing a review, sharing a photo,
            etc.) to share your experience.
            <br />
            <br /> */}
          </div>

          <div
            style={mobile ? styles.endTxtMob : styles.endTxt}
          >
            That&apos;s it! We&apos;re thrilled you&apos;re here! 😄
          </div>
          <Button
            variant='contained'
            color='primary'
            size='small'
            className={btnStyle.button}
            style={{
              background: '#0076BB',
              position: 'relative',
              left: mobile ? '30%' : '44%',
              borderRadius: '20px',
              marginBottom: '2%',
            }}
            onClick={() => {
              onCancel();
            }}
          >
            Continue
          </Button>
        </CardText>
      </Card>
    </Dialog>
  );
};

PaidMediaDialog.propTypes = {
  onCancel: PropTypes.func.isRequired,
  open: PropTypes.bool,
};

export default PaidMediaDialog;
